import { Box, Typography } from '@mui/material'
import { TpChip } from '~/components/tp-chip'
import { TpTooltip } from '~/components'
import { useCropModalContext } from '../context/crop-modal-context'
import { EXCLUDED_PHASE_TYPES } from '../constants/crop-modal-constants'
import { PHASE_ORDER } from '../generators/generate-preview-schedule-data'

export const CropPhaseChips = ({ cropPhaseTypes, effectivePhaseCodes, activePropagationCode, onPhaseToggle }) => {
  const { species, lifecycleType, isCustomCrop } = useCropModalContext()
  const isPerennial = lifecycleType === 'perennial'
  const showChips = activePropagationCode || species || isCustomCrop

  return (
    <Box>
      <Box sx={{ pb: 1 }}>
        <Typography variant='subtitle1'>Adjust Crop Schedule</Typography>
        <Typography variant='body2' color='text.secondary'>
          These are estimates, you'll be able to submit task reports later
        </Typography>
      </Box>
      {showChips && cropPhaseTypes?.length > 0 && (
        <Box
          justifyContent={{ xs: 'center', sm: 'flex-start' }}
          sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 1 }}
        >
          {[...cropPhaseTypes]
            .filter(pt => !EXCLUDED_PHASE_TYPES.includes(pt.code))
            .filter(pt => !(pt.code === 'dormant' && !isPerennial))
            .filter(pt => !(pt.code === 'decomposition' && isPerennial))
            .sort((a, b) => PHASE_ORDER.indexOf(a.code) - PHASE_ORDER.indexOf(b.code))
            .map((phaseType) => {
              const isSelected = effectivePhaseCodes?.includes(phaseType.code)
              return (
                <TpTooltip key={phaseType.code} title={phaseType.description} enterDelay={500} followCursor>
                  <TpChip
                    isSelected={isSelected}
                    label={phaseType.name}
                    onClick={() => onPhaseToggle(phaseType.code)}
                  />
                </TpTooltip>
              )
            })
          }
        </Box>
      )}
    </Box>
  )
}
